import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { View, Text, Dimensions, StyleSheet } from "react-native";

const WIDTH = Dimensions.get('window').width;
const paddingHorizontal = WIDTH >= 1200 ? (WIDTH - 1200) / 2 : 100;

const Footer = () => {

    const [padding, setPadding] = useState(100);

    useEffect(() => {
        if (/(camps)/.test(location.pathname)) {
            setPadding(paddingHorizontal);
        } else {
            setPadding(100);
        }
    }, [location.pathname]);

    const styles = StyleSheet.create({
        divider: {
            height: 1,
            backgroundColor: 'lightgray',
            width: '100%',
            marginTop: 50,
        },
        sectionTitle: {
            fontSize: 16,
            fontWeight: '500',
            marginBottom: 20,
        },
        sectionText: {
            fontSize: 14,
            fontWeight: '300',
        },
        section: {
            flexDirection: 'column',
            marginTop: 50,
        },
        snapcampSection: {
            flexDirection: 'column',
            marginTop: 50,
        },
        link: {
            marginBottom: 10,
            textDecorationLine: 'none',
        },
    });

    return (
    <>
        <View style={[styles.divider, {marginTop: 50}]}></View>

        <View style={{ paddingHorizontal: padding, backgroundColor: '#EDF0F0'}}>
            <View style={
                {
                    flexDirection: 'row',
                    justifyContent:'space-between',
                }
            }>

                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>Support</Text>

                    <Link
                        to="/help-center"
                        style={styles.link}
                    >
                        <Text style={styles.sectionText}>Help center</Text>
                   </Link>
                   <Link
                       to="/contact-us"
                       style={styles.link}
                   >
                       <Text style={styles.sectionText}>Contact us</Text>
                   </Link>
                   <Link
                       to="/camp-safety"
                       style={styles.link}
                   >
                       <Text style={styles.sectionText}>Camp safety</Text>
                   </Link>
                   <Link
                       to="/privacy-policy"
                       style={styles.link}
                   >
                       <Text style={styles.sectionText}>Privacy policy</Text>
                   </Link>
                </View>

                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>Hosting</Text>

                    <Link
                       to="/hosting-create-camp"
                       style={styles.link}
                    >
                       <Text style={styles.sectionText}>Start your SnapCamp</Text>
                    </Link>
                    <Link
                       to="/hosting-resources"
                       style={styles.link}
                    >
                       <Text style={styles.sectionText}>Hosting resources</Text>
                    </Link>
                    <Link
                       to="/community-forum"
                       style={styles.link}
                    >
                       <Text style={styles.sectionText}>Community forum</Text>
                    </Link>
                    <Link
                       to="/host-responsibilities"
                       style={styles.link}
                    >
                       <Text style={styles.sectionText}>Host responsibilities</Text>
                    </Link>
                </View>

                <View style={styles.snapcampSection}>
                    <Text style={styles.sectionTitle}>SnapCamp</Text>

                    <Link
                       to="/announcements"
                       style={styles.link}
                    >
                       <Text style={styles.sectionText}>Announcements</Text>
                    </Link>
                    <Link
                       to="/tutorials"
                       style={styles.link}
                    >
                       <Text style={styles.sectionText}>Tutorials</Text>
                    </Link>
                    <Link
                        to="/careers"
                        style={styles.link}
                    >
                       <Text style={styles.sectionText}>Careers</Text>
                    </Link>
                    <Link
                        to="/investors"
                        style={styles.link}
                    >
                       <Text style={styles.sectionText}>Investors</Text>
                    </Link>
                </View>
            </View>

            <View style={{ height:1, width: '100%', backgroundColor: 'lightgray', marginTop: 30}}></View>

            <View style={{ flexDirection: 'row', marginTop: 30, marginBottom: 30 }}>
                <Text>{['© ' + new Date().getFullYear() + ' SnapCamp, Inc.', 'Terms', 'Sitemap', 'Privacy'].join(' \u2022 ')} </Text>
            </View>
        </View>
    </>
    )
};

export default Footer;